import IDMGlobals from './../IDMGlobals';
import IDMUtils from './../IDMUtils';
//
import URLQuery,{ getUrlParams } from 'query-string-manipulator';
const base64 = require('base-64');
const urlParse = require('url-parse');
//
export default class URLManager {
  constructor(datasource) {
    this.datasource = datasource;
  }
/*public methods - IDM client/mgmt ui specific methods*/
  async getRedirectURL(authDomain, authPath, optUsr, optRole, optCBURL, optContext, forceNoCallback) {
    //build dynamic object
    let params = {};
    //Impersonate thing
    if (!this.datasource.opts.disableImpersonatingApp) {
      const hash = await this.datasource.currentAppIDHash();
      params[IDMGlobals.URLQueryParam_AppID] = hash;
    }
    //Additional values
    if (optRole) params[IDMGlobals.URLQueryParam_ClientEnrollRole] = base64.encode(JSON.stringify(optRole));
    if (optContext) params[IDMGlobals.URLQueryParam_ExtraContext] = base64.encode(JSON.stringify(optContext));
    if (optUsr) params[IDMGlobals.URLQueryParam_UserEmail] = optUsr;
    //Compatibility mode
    if (optCBURL) params[IDMGlobals.URLQueryParam_ClientCallbackURL] = base64.encode(optCBURL);
    else if (!forceNoCallback) params[IDMGlobals.URLQueryParam_ClientCallbackURL] = base64.encode(window.location);
    //Redirect
    return this._newDomainURL(authDomain + authPath, params);
  }
  async redirectRequest(authDomain, authPath, optUsr, optRole, optCBURL, optContext, forceNoCallback) {
    //build dynamic object
    let params = {};
    //Impersonate thing
    if (!this.datasource.opts.disableImpersonatingApp) {
      const hash = await this.datasource.currentAppIDHash();
      params[IDMGlobals.URLQueryParam_AppID] = hash;
    }
    //Additional values
    if (optRole) params[IDMGlobals.URLQueryParam_ClientEnrollRole] = base64.encode(JSON.stringify(optRole));
    if (optContext) params[IDMGlobals.URLQueryParam_ExtraContext] = base64.encode(JSON.stringify(optContext));
    if (optUsr) params[IDMGlobals.URLQueryParam_UserEmail] = optUsr;
    //Compatibility mode
    if (optCBURL) params[IDMGlobals.URLQueryParam_ClientCallbackURL] = base64.encode(optCBURL);
    else if (!forceNoCallback) params[IDMGlobals.URLQueryParam_ClientCallbackURL] = base64.encode(window.location);
    //Redirect
    this.redirectTo(authDomain + authPath, params);
  }
  async redirectBack(callbackURL, includeSSO) { 
    if (includeSSO) callbackURL = await this._appendSSOIntoURL(callbackURL);
    this.setURL(callbackURL); 
  }
  async loadFederationState() {
    await this._normalizeFederationStateQuery();
  }

  //Information carry-on
  /** getAppID - Return current window url appID if any set. */
  getAppID() { return this.getParam(IDMGlobals.URLQueryParam_AppID); }
  /** getEnrollmentRole - Return current window url client enrollment role if any set. */
  getEnrollmentRole() {
    let decodedVal = null;
    try {
      const val = this.getParam(IDMGlobals.URLQueryParam_ClientEnrollRole, false, true);
      if (val) decodedVal = JSON.parse(val);
    } catch (e) {}
    return decodedVal;
  }
  /** getExtraContext - Return current window extra context if any set. */
  getExtraContext() {
    let decodedVal = null;
    try {
      const val = this.getParam(IDMGlobals.URLQueryParam_ExtraContext, false, true);
      if (val) decodedVal = JSON.parse(val);
    } catch (e) {}
    return decodedVal;
  }
  /** getCallbackURL - Return current window call back URL */
  getCallbackURL() {
    return this.getParam(IDMGlobals.URLQueryParam_ClientCallbackURL, false, true);
  }
  /** getEnrollmentRole - Return current window url client specified email. */
  getUserEmail() { return this.getParam(IDMGlobals.URLQueryParam_UserEmail); }

/*public methods - Generic URL management methods*/
  /**
   * getCurrentURL - Get current window URL safely. If on nodejs enviroment it will return null.
   *
   * @param  {boolean} noProtocol Flag to indicate if should include current protocol or not.
   * @return {string}            The current window URL. Null if on nodejs enviroment.
   */
  getCurrentURL(noProtocol) {
    if (!IDMUtils.isNodeJS()) {
      if (noProtocol) return window.location.href.replace('http://','').replace('https://','');
      return window.location.href;
    } return null;
  }
  /**
   * setURL - Set current window URL, if not on Nodejs enviroment.
   *
   * @param  {URL} _url The URL to be set on the current window.
   */
  setURL(_url) { if (!IDMUtils.isNodeJS()) window.location.href = _url; }
  /**
   * getParam - Get current window url query parameter with insensitiveness.
   *
   * @param  {string} paramName The param to be get on the URL (case insensitive)
   * @return {string}           The value of the parameter. Null if not found.
   */
  getParam(paramName, replace, base64Decode) {
    try {
      let p = IDMUtils.caseInsensitiveObjectForKeyOnArray(getUrlParams((replace ? this.getCurrentURL().replace('#', '?') : this.getCurrentURL())), paramName);
      if (p) p = decodeURIComponent(p);
      if (p && base64Decode) p = base64.decode(p);
      return p;
    } catch (e) {}
    return null;
  }
  /**
   * setParam - Set current window URL query parameter.
   *
   * @param  {string} paramName The parameter to be set.
   * @param  {string} value     The value of the parameter to be set.
   */
  setParam(paramName, value) {
    //build dynamic object
    let setObj = {set: {}};
    setObj.set[paramName] = value;
    //set url with new parameter
    this.setURL(URLQuery(this.getCurrentURL(), setObj));
  }
  /**
   * hasParam - Check if current window URL has query parameter.
   *
   * @param  {string} paramName The parameter to be checked
   * @return {boolean}          Return if the specified parameter exists and is valid.
   */
  hasParam(paramName) {
    let val = this.getParam(paramName);
    return (val && val.length && val.length > 0);
  }
  /**
   * delParam - Delete specified param current window URL query parameter.
   *
   * @param  {string} paramName The parameter to be deleted.
   */
  deleteParam(paramName) { this._updateQueryStringParam(paramName); }
  /**
   * redirectTo - Redirects the current window to the specified domain and parameters.
   *
   * @param  {string} domain The domain+path to be redirected
   * @param  {object} params The query parameters to be added on the request (object for key/name for value)
   */
  redirectTo(domain, params) {
    //redirect
    this.setURL(this._newDomainURL(domain, params));
  }

/*private methods*/
  /** _newDomainURL - Generates a new domain URL with the current window protocol. */
  _newDomainURL(_domain, params) {
    //add values
    let setObj = {set: {}};
    for (let paramName in params) setObj.set[paramName] = params[paramName];
    //
    const curr = urlParse(this.getCurrentURL());
    return URLQuery(`${curr.protocol}//${_domain || curr.hostname}`, setObj);
  }

  _updateQueryStringParam(key, value) { // - https://gist.github.com/excalq/2961415
    let baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
      urlQueryString = document.location.search,
      newParam = key + '=' + value,
      params = '?' + newParam;
    // If the "search" string exists, then build params from it
    if (urlQueryString) {
      var updateRegex = new RegExp('([\?&])' + key + '[^&]*');
      var removeRegex = new RegExp('([\?&])' + key + '=[^&;]+[&;]?');
      if (typeof value == 'undefined' || value == null || value == undefined || value == '') { // Remove param if value is empty
        params = urlQueryString.replace(removeRegex, "$1");
        params = params.replace(/[&;]$/, "");
      } else if (urlQueryString.match(updateRegex) !== null) { // If param exists already, update it
        params = urlQueryString.replace(updateRegex, "$1" + newParam);
      } else { // Otherwise, add it to end of query string
        params = urlQueryString + '&' + newParam;
      }
    }
    // no parameter was set so we don't need the question mark
    params = params == '?' ? '' : params;
    window.history.replaceState({}, "", baseUrl + params);
  }
    //private
  async _appendSSOIntoURL(url) {
    //SSO it
    const ssoResp = await this.datasource.api.authorization.generateSSOCode();
    if (ssoResp.statusCode === 200 && ssoResp.body.code) {
      const code = encodeURIComponent(ssoResp.body.code);
      if (url.includes('?')) url += `&scode=${code}`;
      else url += `?scode=${code}`;
    } else console.error(`SSO error`, ssoResp);
    return url;
  }
  async _normalizeFederationStateQuery() {
		try {
        let state = this.getParam('state', true /* fed provider does send # at the end of the url :/ */, true);
        //Persistent context BUGFIX Logic (OPD-335) - 'Might have other occureces in the code'
        if (!state) {
          state = await this.datasource.session.data.storage.getValue(IDMGlobals.CookiesKey_IDMLogoutStateBugfix);
          if (state) state = base64.decode(decodeURIComponent(state));
        }
        await this.datasource.session.data.storage.cleanKey(IDMGlobals.CookiesKey_IDMLogoutStateBugfix);
        if (!state) return;
        //
				const v = JSON.parse(state);
				if (Array.isArray(v) && v.length > 0) {
					for (const param of v) if (param.key && param.value) this._updateQueryStringParam(param.key, param.value)
				}
        this._updateQueryStringParam('state', null);
			} catch (e) {}
	}
}
